export interface HeroSlide {
  movieId: string;
  backdrop: string;
  tagline: string;
}

export const heroSlides: HeroSlide[] = [
  {
    movieId: "m001",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%20of%20a%20lone%20astronaut%20floating%20before%20a%20massive%20glowing%20planet%20and%20nebula%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grading%2C%20dramatic%20atmospheric%20lighting%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=qx-hero-01&orientation=landscape",
    tagline: "穿越光年的尽头，寻找人类最后的答案",
  },
  {
    movieId: "t003",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20chinese%20mythology%20cinematic%20scene%20of%20a%20warrior%20facing%20a%20giant%20mythical%20beast%20on%20misty%20mountains%2C%20deep%20navy%20and%20fiery%20orange%20color%20grading%2C%20grand%20dramatic%20lighting%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=qx-hero-02&orientation=landscape",
    tagline: "上古神兽觉醒，苍生命运由此改写",
  },
  {
    movieId: "m003",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20spaceship%20traveling%20through%20a%20vivid%20colorful%20nebula%20with%20countless%20stars%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grading%2C%20epic%20lighting%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=qx-hero-03&orientation=landscape",
    tagline: "当时间与空间扭曲，唯有爱能跨越光年",
  },
  {
    movieId: "t001",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20chinese%20tang%20dynasty%20capital%20city%20at%20night%20glowing%20with%20lanterns%20and%20palaces%2C%20deep%20navy%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20lighting%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=qx-hero-04&orientation=landscape",
    tagline: "十二个时辰，能否改写一座都城的命运",
  },
];